module.exports = __webpack_public_path__ + "img/btn-solar-system.238f98c4.svg";